module.exports = __webpack_public_path__ + "img/default_profile.747ac90e.png";